// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link_Link__cYhAw","Link___sm":"Link_Link___sm__le0cy","Link___secondary":"Link_Link___secondary__8j_Bx"};